const features = [
  {
    icon: 'ri-movie-2-line',
    title: '海量全集免费看',
    desc: '收录2000+部国产剧韩剧全集，每日同步更新最新电视剧，高清画质全程免费在线观看，情侣追剧无需付费。',
  },
  {
    icon: 'ri-heart-2-line',
    title: '情侣专属推荐',
    desc: '根据情侣观影偏好智能推荐甜宠剧和经典韩剧，打造属于两个人的追剧片单，让每一次追剧都甜蜜加倍。',
  },
  {
    icon: 'ri-device-line',
    title: '多端同步追剧',
    desc: '支持手机、平板和电脑多端无缝切换，无论在家窝沙发还是通勤路上，追剧进度自动同步，随时随地继续看。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            为什么情侣都选我们追剧
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            三⼤核⼼优势，让每一对情侣都能享受最舒适的追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-secondary-200/70 rounded-2xl p-8 text-center transition-all hover:border-primary-200/60"
            >
              <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-800 mb-3">{item.title}</h3>
              <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}